import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Report as action } from '../../redux/actions';

/**
 * Create a new copy of the report
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const reports = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
    DuplicateReport: props.data.duplicateReport,
  };

  fetch(endpoint('/duplicate-report'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.create({
            Name: model.DuplicateReport,
          }));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default reports;
